import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import noImageAvailable from "../assets/no-image-available.svg";

const SiteImage = ({
  src,
  alt = "No image available",
  sx = {},
  ...props
}) => {
  const [imageSrc, setImageSrc] = useState(src || noImageAvailable);

  useEffect(() => {
    setImageSrc(src || noImageAvailable);
  }, [src]);

  const handleError = () => {
    if (imageSrc !== noImageAvailable) {
      setImageSrc(noImageAvailable);
    }
  };

  return (
    <Box
      component="img"
      src={imageSrc}
      alt={alt}
      onError={handleError}
      sx={{
        display: "block",
        width: "100%",
        height: 180,
        objectFit: "cover",
        bgcolor: "grey.100",
        ...sx,
      }}
      {...props}
    />
  );
};

export default SiteImage;
